import { invalidValidationError, missingAllData, draftErrors } from 'mocks/server/data/draftErrors';
import { baseFrame } from 'mocks/server/data/frames';
import {
  baseEntityWithEmptyFields,
  baseEntityWithNullFields,
} from 'mocks/server/data/generation/generateBaseEntity';
import { IDraftFrame } from 'types/detailsEntityType';
import { EntityType } from 'types/entityType';
import { DraftStatus, LiveStatus } from 'utils/statuses';

export const draftFrameWithNullFields: IDraftFrame = {
  ...baseEntityWithNullFields('nullFrame', EntityType.FRAME),
  broadsignFrames: null,
  status: DraftStatus.INCOMPLETE,
  intendedLiveStatus: LiveStatus.ARCHIVED,
  draftErrors: [missingAllData],
};

export const draftFrameWithEmptyFields: IDraftFrame = {
  ...baseEntityWithEmptyFields('emptyFrame', EntityType.FRAME),
  broadsignFrames: [],
  status: DraftStatus.INCOMPLETE,
  intendedLiveStatus: LiveStatus.ARCHIVED,
  draftErrors: [missingAllData],
};

export const draftFrameWithNullFieldsComparedToLive: IDraftFrame = {
  ...baseEntityWithNullFields('nullFramevsLive', EntityType.FRAME),
  broadsignFrames: null,
  status: DraftStatus.INCOMPLETE,
  intendedLiveStatus: LiveStatus.ARCHIVED,
  draftErrors: [missingAllData],
};

export const draftFrameWithEmptyFieldsComparedToLive: IDraftFrame = {
  ...baseEntityWithEmptyFields('emptyFramevsLive', EntityType.FRAME),
  broadsignFrames: [],
  status: DraftStatus.INCOMPLETE,
  intendedLiveStatus: LiveStatus.ARCHIVED,
  draftErrors: [missingAllData],
};

export const allNewFieldsDraftFrame: IDraftFrame = {
  ...baseFrame,
  spaceId: 'NewFrame',
  status: DraftStatus.READY,
  intendedLiveStatus: LiveStatus.INACTIVE,
};

export const allUpdatedFieldsDraftFrame: IDraftFrame = {
  ...baseFrame,
  spaceId: 'UpdatedFrame',
  status: DraftStatus.READY,
  intendedLiveStatus: LiveStatus.INACTIVE,
  consolidatedResolutions: ['1280x720', '2560x1440', '3840x2160'],
  auctionToSpotTimeMinutes: 120,
  operatingHours: {
    MONDAY: ['06:00 - 21:29'],
    TUESDAY: ['06:00 - 21:29'],
    WEDNESDAY: ['06:00 - 21:29'],
    THURSDAY: ['06:00 - 21:29'],
    FRIDAY: ['06:00 - 21:29'],
    SATURDAY: ['06:00 - 21:29'],
    SUNDAY: ['06:00 - 21:29'],
  },
};

export const syncingDraftFrame: IDraftFrame = {
  ...baseFrame,
  spaceId: 'syncingFrame',
  status: DraftStatus.SYNCING,
  intendedLiveStatus: LiveStatus.ACTIVE,
};

export const errorDraftFrame: IDraftFrame = {
  ...baseFrame,
  spaceId: 'errorFrame',
  status: DraftStatus.ERROR,
  intendedLiveStatus: LiveStatus.ACTIVE,
  draftErrors: draftErrors,
};

export const invalidDraftFrame: IDraftFrame = {
  ...baseFrame,
  spaceId: 'invalidFrame',
  status: DraftStatus.INVALID,
  intendedLiveStatus: LiveStatus.ACTIVE,
  draftErrors: [invalidValidationError],
};

export const draftFrame: IDraftFrame = {
  ...baseFrame,
  spaceId: '11111111111',
  status: DraftStatus.READY,
  intendedLiveStatus: LiveStatus.ACTIVE,
};

export const draftFrameWithLive: IDraftFrame = {
  ...baseFrame,
  spaceId: 'frameWithDraft',
  status: DraftStatus.READY,
  intendedLiveStatus: LiveStatus.INACTIVE,
};
export const generateDraftFrames = (): IDraftFrame[] => {
  return [
    draftFrameWithNullFields,
    draftFrameWithEmptyFields,
    draftFrameWithNullFieldsComparedToLive,
    draftFrameWithEmptyFieldsComparedToLive,
    allNewFieldsDraftFrame,
    allUpdatedFieldsDraftFrame,
    syncingDraftFrame,
    errorDraftFrame,
    invalidDraftFrame,
    draftFrame,
    draftFrameWithLive,
  ];
};
